import { DraftJob, Job } from "@/modules/types/job";
import { create } from "zustand";

interface DraftJobState {
  draftJobMenu: DraftJob[];
  draftJobs: Job[];
}

interface DraftJobActions {
  setDraftJobMenu: (menu: DraftJob[]) => void;
  setDraftJobs: (jobs: Job[]) => void;
  appendDraftJobs: (jobs: Job[]) => void;
  appendDraftJobMenu: (menu: DraftJob[]) => void;
  reset: () => void;
}

export type DraftJobStore = DraftJobState & DraftJobActions;

const initialState: DraftJobState = {
  draftJobMenu: [],
  draftJobs: [],
};

export const useDraftJobStore = create<DraftJobStore>((set) => ({
  ...initialState,
  setDraftJobMenu: (draftJobMenu) => set({ draftJobMenu }),
  setDraftJobs: (draftJobs) => set({ draftJobs }),
  appendDraftJobs: (draftJobs) =>
    set((state) => ({ draftJobs: [...state.draftJobs, ...draftJobs] })),
  appendDraftJobMenu: (draftJobMenu) =>
    set((state) => ({ draftJobMenu: [...state.draftJobMenu, ...draftJobMenu] })),
  reset: () => set(initialState),
}));
